import { render, staticRenderFns } from "./MessageText.vue?vue&type=template&id=086e9f14&scoped=true&"
import script from "./MessageText.vue?vue&type=script&lang=js&"
export * from "./MessageText.vue?vue&type=script&lang=js&"
import style0 from "./MessageText.vue?vue&type=style&index=0&id=086e9f14&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086e9f14",
  null
  
)

export default component.exports